import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
import './assets/icons' // icon

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import request from "@/api/request"
Vue.prototype.$request = request


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
